import React, { useContext } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DataContext } from "../../../../../../providers/ElectricityCheckoutDataProvider";
import Input from "../../../../../shared/forms/NewInput";
import { SalutationSelect } from "../../../../../shared/forms/NewSelect";
import Margin from "../../../../../shared/Margin";
import Headline from "../../../../../shared/NewHeadline";
import Section from "../../../../../shared/Section";

const ZipcodeCityField = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

const ZipcodeWrapper = styled.div`
    display: flex;
    margin-right: 10px;
`;

const CityWrapper = styled.div`
    display: flex;
    flex-grow: 1;
`;

const fullWidthStyles = css`
    width: 100%;
`;

const InvoiceAddress = () => {
    const dataContext = useContext(DataContext);
    const { invoiceAddress } = dataContext.data;
    const { setInvoiceAddress, addFormError, clearFormError, hasFormErrorAt } =
        dataContext.actions;

    const handleChange = (event) => {
        setInvoiceAddress({
            ...invoiceAddress,
            ...{ [event.target.name]: event.target.value },
        });
    };

    return (
        <React.Fragment>
            <Section withMargin>
                <Headline>Rechnungsadresse</Headline>
                <div className="field">
                    <div className="control">
                        <Input
                            id="invoice_company"
                            name="invoice_company"
                            value={invoiceAddress.invoice_company}
                            placeholder="Firma (optional)"
                            validation="company"
                            forceError={hasFormErrorAt("invoice_company")}
                            onError={() => addFormError("invoice_company")}
                            onErrorSolved={() =>
                                clearFormError("invoice_company")
                            }
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="field" css={fullWidthStyles}>
                    <div className="field">
                        <div className="control">
                            <SalutationSelect
                                id="invoice_salutation"
                                name="salutation"
                                onChange={handleChange}
                                value={invoiceAddress.salutation}
                            />
                        </div>
                    </div>
                </div>

                <div className="field" css={fullWidthStyles}>
                    <div className="control">
                        <Input
                            id="invoice_firstname"
                            name="invoice_firstname"
                            value={invoiceAddress.invoice_firstname}
                            placeholder="Vorname"
                            validation="name"
                            forceError={hasFormErrorAt("invoice_firstname")}
                            onError={() => addFormError("invoice_firstname")}
                            onErrorSolved={() =>
                                clearFormError("invoice_firstname")
                            }
                            onChange={handleChange}
                            fullWidth
                        />
                    </div>
                </div>
                <div className="field">
                    <div className="control">
                        <Input
                            id="invoice_lastname"
                            name="invoice_lastname"
                            value={invoiceAddress.invoice_lastname}
                            placeholder="Nachname"
                            validation="name"
                            forceError={hasFormErrorAt("invoice_lastname")}
                            onError={() => addFormError("invoice_lastname")}
                            onErrorSolved={() =>
                                clearFormError("invoice_lastname")
                            }
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <Margin top="20" className="field">
                    <div className="control">
                        <Input
                            id="invoice_email"
                            name="invoice_email"
                            value={invoiceAddress.invoice_email}
                            placeholder="E-Mail"
                            validation="email"
                            forceError={hasFormErrorAt("invoice_email")}
                            onError={() => addFormError("invoice_email")}
                            onErrorSolved={() =>
                                clearFormError("invoice_email")
                            }
                            onChange={handleChange}
                        />
                    </div>
                </Margin>
                <div className="field">
                    <div className="control">
                        <Input
                            id="invoice_phone"
                            name="invoice_phone"
                            value={invoiceAddress.invoice_phone}
                            placeholder="Telefon"
                            validation="phone"
                            forceError={hasFormErrorAt("invoice_phone")}
                            onError={() => addFormError("invoice_phone")}
                            onErrorSolved={() =>
                                clearFormError("invoice_phone")
                            }
                            onChange={handleChange}
                        />
                    </div>
                </div>
                <Input
                    id="invoice_street"
                    name="invoice_street"
                    value={invoiceAddress.invoice_street}
                    placeholder="Straße und Hausnummer"
                    validation="street"
                    forceError={hasFormErrorAt("invoice_street")}
                    onError={() => addFormError("invoice_street")}
                    onErrorSolved={() => clearFormError("invoice_street")}
                    onChange={handleChange}
                />

                <ZipcodeCityField className="field">
                    <ZipcodeWrapper>
                        <Input
                            id="invoice_zipcode"
                            name="invoice_zipcode"
                            value={invoiceAddress.invoice_zipcode}
                            placeholder="Postleitzahl"
                            validation="zipcode"
                            forceError={hasFormErrorAt("invoice_zipcode")}
                            onError={() => addFormError("invoice_zipcode")}
                            onErrorSolved={() =>
                                clearFormError("invoice_zipcode")
                            }
                            onChange={handleChange}
                            fullWidth
                        />
                    </ZipcodeWrapper>

                    <CityWrapper>
                        <Input
                            id="invoice_city"
                            name="invoice_city"
                            value={invoiceAddress.invoice_city}
                            placeholder="Ort"
                            validation="city"
                            forceError={hasFormErrorAt("invoice_city")}
                            onError={() => addFormError("invoice_city")}
                            onErrorSolved={() => clearFormError("invoice_city")}
                            onChange={handleChange}
                            fullWidth
                        />
                    </CityWrapper>
                </ZipcodeCityField>
            </Section>
        </React.Fragment>
    );
};

export default InvoiceAddress;
